import '../../base/style/index.mjs';
import 'element-plus/theme-chalk/src/col.scss';
//# sourceMappingURL=index.mjs.map
